<template>
  <div class="content-block">
    <h2 class="mb-4">
      About
    </h2>
    <p v-html="text" />
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-facing-decorator'

@Component({})
export default class PropertyAbout extends Vue {
  @Prop({ type: String }) text!: string
}
</script>
